// Sends the shopper to the collection URL held by the selected vehicle option.
class SVehicleFinder extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const form = this.querySelector('form');
    if (!form) return;
    form.addEventListener(
      'submit',
      (event) => {
        const select = form.querySelector('select');
        const destination = select?.value;
        if (!destination) return;
        event.preventDefault();
        window.location.assign(destination);
      },
      { signal: this.#controller.signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-vehicle-finder')) customElements.define('s-vehicle-finder', SVehicleFinder);
